export default __webpack_public_path__ + "static/media/image.33ea901b.png";